import { Badge, Box } from "@mui/material";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";

import AccountIcon from "../../assets/DesktopNavBox/AccountIcon.svg";
import FinancialIcon from "../../assets/DesktopNavBox/FinancialIcon.svg";
import GigsIcon from "../../assets/DesktopNavBox/GigsIcon.svg";
import HomeIcon from "../../assets/DesktopNavBox/HomeIcon.svg";
import MessagesIcon from "../../assets/DesktopNavBox/MessagesIcon.svg";
import SearchIcon from "../../assets/DesktopNavBox/SearchIcon.svg";
import Tabs from "../../constants/tabs";
import useCheckUnreadMessages from "../../customHooks/useCheckUnreadMessages";
import { theme } from "../../mui-customs/Theme";
import { setTab } from "../../redux/createTabSlice";
import { RootState } from "../../redux/store";
import ProfileCompleteness from "../ProfileCompleteness";
import NavButton from "./NavButton";

const DesktopNavBox = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const activeTab = useSelector(
    (state: RootState) => state.activeTab.activeTab
  );
  const { notificationBadge, messageBadge } = useSelector(
    (state: RootState) => state.messaging
  );

  const userUid = useSelector((state: RootState) => state.user.user.uid);
  useCheckUnreadMessages();

  return (
    <Box
      sx={{
        py: 4,
        px: 3,
        backgroundColor: theme.whiteBg.WBG1,
        borderRadius: "8px",
      }}
    >
      {userUid && <ProfileCompleteness sx={{ mb: 4 }} />}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "40px",
          justifyContent: "space-around",
        }}
      >
        <NavButton
          onClick={() => {
            if (!userUid) {
              router.push(`/auth/sign-up`);
              return;
            }
            router.push(`/gigs/${userUid}`);
            dispatch(setTab(Tabs.Gigs));
          }}
          isActive={activeTab === Tabs.Gigs}
          imageSrc={GigsIcon}
          label="Gigs"
        />
        <NavButton
          imageSrc={FinancialIcon}
          label="Financial"
          isActive={activeTab === Tabs.Finance}
          onClick={() => {
            if (!userUid) {
              router.push(`/auth/sign-up`);
              return;
            }
            router.push("/finance");
            dispatch(setTab(Tabs.Finance));
          }}
        />
        <Badge
          variant="dot"
          color="error"
          invisible={notificationBadge && messageBadge}
        >
          <NavButton
            onClick={() => {
              if (!userUid) {
                router.push(`/auth/sign-up`);
                return;
              }
              router.push(`/message`);
              dispatch(setTab(Tabs.Message));
            }}
            isActive={activeTab === Tabs.Message}
            imageSrc={MessagesIcon}
            label="Messages"
          />
        </Badge>
        <NavButton
          onClick={() => {
            if (!userUid) {
              router.push(`/auth/sign-up`);
              return;
            }
            router.push("/");
            dispatch(setTab(Tabs.Home));
          }}
          isActive={activeTab === Tabs.Home}
          imageSrc={HomeIcon}
          label="Home"
        />
        <NavButton
          onClick={() => {
            if (!userUid) {
              router.push(`/auth/sign-up`);
              return;
            }
            router.push(`/profile/${userUid}`);
            dispatch(setTab(Tabs.Profile));
          }}
          isActive={activeTab === Tabs.Profile}
          imageSrc={AccountIcon}
          label="Profile"
        />
        <NavButton
          imageSrc={SearchIcon}
          label="Search"
          onClick={() => {
            router.push("/browse");
            dispatch(setTab(Tabs.Search));
          }}
          isActive={activeTab === Tabs.Search}
        />
      </Box>
    </Box>
  );
};

export default DesktopNavBox;
